export default __webpack_public_path__ + "0276558a36f5314f205097c9d25f21f5.svg";